// Polyfill
import 'core-js/stable';
import 'custom-event-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { CookiesProvider } from 'react-cookie';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import i18n from './i18n/index';
import store from './store/index';
import App from './components/App';
import themeStyles from '../apps/shared/theme';
import ErrorBoundary from './components/parts/Error/ErrorBoundary';

// Google analytics
ReactGA.initialize(googleAnaylticsId);
ReactGA.pageview(window.location.pathname + window.location.search);

// React sticky table styles
import 'react-sticky-table/dist/react-sticky-table.css';

// App styles
import './css/index.css';

const theme = createMuiTheme(themeStyles);

ReactDOM.render(
  (
    <I18nextProvider i18n={i18n}>
      <SnackbarProvider maxSnack={3}>
        <CookiesProvider>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <ThemeProvider theme={theme}>
              <Provider store={store}>
                <ErrorBoundary location="index.js">
                  <App useSuspense={false} />
                </ErrorBoundary>
              </Provider>
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </CookiesProvider>
      </SnackbarProvider>
    </I18nextProvider>
  ),
  document.getElementById('root'),
);

serviceWorker.unregister();
